import * as Yup from 'yup';

export const loginFormSchema = Yup.object({
  email: Yup.string().email('Email must be valid').required('Please enter a valid email address.'),
  password: Yup.string().required(),
});
